import service from '@/utils/server';

const modName='/bd/qc/';
//查询可操作开始采样的采样数据
export const pageInfo = data => {
  return service({
    url: modName + 'getEndQcPageInfo',
    method: 'post',
    data
  });
};

//开始采样
export const endQc = data => {
  return service({
    url: modName + 'endQc',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/bd/qc/end/api/index.js